export default "__VITE_ASSET__CWbKXOwB__"